module.exports = __webpack_public_path__ + "static/media/tommySleeveHood0.e057bd9a.svg";